module.exports = __webpack_public_path__ + "static/media/8.576f7a4f.jpg";